import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateCalendarExportRule as UpdateCalendarExportRuleMutation,
    UpdateCalendarExportRuleVariables as UpdateCalendarExportRuleVariables,
} from 'nutshell-graphql-types';

import UPDATE_CALENDAR_EXPORT_RULE from '../mutations/update-calendar-export-rule.graphql';

export const useUpdateCalendarExportRule = (): {
    updateCalendarExportRule: (input: UpdateCalendarExportRuleVariables) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateCalendarExportRule, {loading, error}] = useMutation<
        UpdateCalendarExportRuleMutation,
        UpdateCalendarExportRuleVariables
    >(UPDATE_CALENDAR_EXPORT_RULE);

    return {
        updateCalendarExportRule: (input: UpdateCalendarExportRuleVariables) =>
            updateCalendarExportRule({
                variables: input,
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
